<!--工单考核交期变更审批详情-->
<template>
  <div>
    <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
      <ls-card ref="refBaseInfo">
        <template #title>基础信息</template>
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="流程单号">
              <a-input v-model="detail.billNo" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="流程名称">
              <a-input v-model="detail.formName" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请人">
              <a-input v-model="detail.realName" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请时间">
              <a-input v-model="detail.applyTime" disabled />
            </a-form-item>
          </a-col>
        </a-row>
      </ls-card>
      <ls-card ref="refDetailTable">
<!--        <template #title>-->
<!--          <span>详细信息</span>-->
<!--          <a-button type="primary" class="ml10" @click="handleBatchApprove" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'">批准</a-button>-->
<!--          <a-button type="danger" class="ml10" @click="handleBatchReject" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'">拒绝</a-button>-->
<!--        </template>-->
        <a-table
          ref="dataTable"
          :columns="newColumns"
          :data-source="showData"
          rowKey="serialNumber"
          :scroll="{ x: 1600, y: detailTableHeight + 52 }"
          :pagination="false"
        >
          <!-- 车间物控 -->
          <span slot="workshopMcNameTitle">
            <ls-change-component title="车间物控" @change="searchTable" v-model="searchForm.workshopMcName"/>
          </span>
          <!--是否主动变更-->
          <span slot="activePassiveNameTitle">
                <i class="toRequired">*</i>是否主动变更
              </span>
          <template slot="activePassiveName" slot-scope="text, record">
            <a-select v-if="editStatus&&record.workshopMcCode===jobCode" v-model="record.activePassive" @change="onChangeActivePassive(record)">
              <a-select-option v-for="item in updateMethodList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
            <span v-else>{{ text }}</span>
          </template>
          <!--新考核交期-->
          <span slot="newAssessmentDeliveryDateTitle">
                <i class="toRequired">*</i>新考核交期
              </span>
          <template slot="newAssessmentDeliveryDate" slot-scope="text,record">
            <div v-if="editStatus&&record.workshopMcCode===jobCode">
              <a-date-picker
                style="min-width: 160px"
                v-if="record.wipEntityFlag==='COMPONENT_JOB'"
                v-model="record.newAssessmentDeliveryDate"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: moment('12:00:00', 'HH:mm:ss') }"
              />
              <a-date-picker
                v-else
                style="min-width: 160px"
                v-model="record.newAssessmentDeliveryDate" valueFormat="YYYY-MM-DD 23:59:59" />
            </div>
            <div v-else>
              <span v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
              <span v-else>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </div>
          </template>
          <!--变更责任方-->
          <span slot="responsiblePartyNameTitle">
                <i class="toRequired">*</i>变更责任方
              </span>
          <template slot="responsiblePartyName" slot-scope="text,record">
            <a-select
              v-if="editStatus&&record.workshopMcCode===jobCode"
              show-search
              option-filter-prop="children"
              v-model="record.responsibleParty"
              allowClear
              mode="multiple"
              :maxTagCount="2"
              @change="onChangeResponsibleParty(record)">
              <a-select-option v-for="item in changeLiabilityList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
            <span v-else>{{ text }}</span>
          </template>
          <!--变更原因-->
          <span slot="changeReasonTitle">
                <i class="toRequired">*</i>变更原因
              </span>
          <template slot="changeReason" slot-scope="text,record">
            <a-input v-if="editStatus&&record.workshopMcCode===jobCode" type="textarea" :autoSize="{minRows:2}" v-model="record.changeReason" :maxLength="200" />
            <span v-else>{{ text }}</span>
          </template>
          <!--交期变更套数-->
          <span slot="assessmentChangeQuantityTitle">
             <i class="toRequired">*</i>交期变更套数
          </span>
          <template slot="assessmentChangeQuantity" slot-scope="text, record">
            <a-input-number
              style="width: 100%"
              v-if="editStatus&&record.workshopMcCode===jobCode"
              v-model="record.assessmentChangeQuantity"
              :min="0"
              :max="Number(record.planQuantity || 0)"
              :parser="(value) => `${value}`.replace(/\D/g, '')"
              :formatter="(value) => `${value}`.replace(/\D/g, '')"
            />
            <span v-else>{{ text }}</span>
          </template>
          <template slot="assessmentDeliveryDateForm" slot-scope="text, record">
            <span v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            <span v-else>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
        </a-table>
      </ls-card>
      <ls-card title="审批信息"  class="process-log-box">
        <template #extra>
          <a-button
            type="primary"
            :loading="btnLoading"
            v-show="editStatus"
            v-hasPermi="['mes:mesApprovalFlow:agreeApprove']"
            @click="handleApprove('approve')">
            审核
          </a-button>
          <a-button
            type="danger"
            class="ml10"
            style="margin-right: 20px"
            :loading="btnLoading"
            v-show="editStatus"
            v-hasPermi="['mes:mesApprovalFlow:rejectApprove']"
            @click="handleApprove('reject')">
            驳回
          </a-button>
          <span v-if="detail.status === 'APPROVED' || detail.status === 'REJECTED'" :style="{ color: detail.status === 'APPROVED'?'green':'red' }">{{ detail.statusName }}</span>
          <approve-modal
            ref="approveModalRef"
            v-if="editStatus&&showApproveModal"
            :btnLoading="btnLoading"
            :detail="detail"
            @afterApprove="afterApprove"
          />
        </template>
        <ProcessLog
          v-if="processInstanceId"
          ref="processLogRef"
          :params="{processInstanceId:processInstanceId}"
        >
<!--          <template #titleName="{ dataSource }">
            {{ dataSource.type === 2 ? dataSource.taskName : dataSource.actionName }}
          </template>-->
        </ProcessLog>
        <a-empty v-else :imageStyle="{ marginTop: '60px' }" />
      </ls-card>
    </a-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import cacheRequest from '@/mixins/cacheRequest'
import {
  apiKernelFlowExternalBpm,
  apiMesFlowOrderApprovalHeader,
  apiMesFlowPathParamDefineList,
  apiMesGetMesFlowPathLinesList,
  apiMesTerminateProcess, apiUpdateMesFlowPathLines
} from '@/api/approval/approval-process'
import ProcessLog from '@/components/process-log/index.vue';
import approveModal from '@/views/approval/approval-process/components/approve-modal.vue'
import lsChangeComponent from '@/components/LsChangeComponent/ls-change-component.vue'
import debounce from "lodash/debounce";
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep'

import md5 from 'md5'
export default {
  name: 'WorkOrderChangeProcessDetail',
  components: { ProcessLog, approveModal, lsChangeComponent },
  data () {
    return {
      detailType: '4', // 4工单考核交期变更审批、5工单物料变更流程
      // 可编辑字段:activePassiveName是否主动变更,newAssessmentDeliveryDate新考核交期,,responsibleParty变更责任方,changeReason变更原因
      editFieldList: ['activePassiveName', 'newAssessmentDeliveryDate', 'responsiblePartyName', 'changeReason', 'assessmentChangeQuantity'],
      showApproveModal: false,
      updateTypeList: [], // 变更类型
      updateMethodList: [], // 是否主动变更
      changeLiabilityList: [], // 变更责任方
      processInstanceId: '', // 流程实例id
      // 搜索表单
      searchForm: {
        workshopMcName: undefined
      },
      // 防抖触发器
      searchFlag: false,
      detail: {
        billNo: "",
        formName: "",
        realName: "",
        applyTime: "",
        comment: "",
        status: ""
      },
      tableDataSource: [],
      queryParams: {},
      columns: [],
      approvalFlag: '', // 记录审批标识
      newColumns: [], // 根据后端接口重新组装的表头
      headId: '',
      detailTableHeight: 300,
      detailPrevious: null,
      btnLoading: false // 按钮loading状态
    }
  },
  mixins: [cacheRequest],
  computed: {
    ...mapState({
      jobCode: (state) => state.user.jobCode // 登录人为当前行的物料管控人，才允许编辑
    }),
    editStatus () {
      return this.detail?.status !== 'APPROVED' && this.detail?.status !== 'REJECTED'
    },
    showData () {
      if(this.searchForm?.workshopMcName) {
        return this.tableDataSource.filter(item => {
          return item.workshopMcName.includes(this.searchForm.workshopMcName)
        })
      } else {
        return this.tableDataSource
      }
    }
  },
  created () {
    this.cacheLookupRequest('MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', { lookupType: 'MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', current: 1, pageSize: 999 }, 'updateMethodList')
    this.cacheLookupRequest('MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', { lookupType: 'MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', current: 1, pageSize: 999 }, 'updateMethodList')
    this.cacheLookupRequest('MES_JOB_CHANGE_LIABILITY', { lookupType: 'MES_JOB_CHANGE_LIABILITY', current: 1, pageSize: 999 }, 'changeLiabilityList')
    // this.processInstanceId = this.$route?.query?.processInstanceId
    this.headId = this.$route?.query?.bpmBillNo
    this.detailType = this.$route?.query?.detailType ? this.$route.query.detailType : '4'
    this.initGetTable();
    if(this.headId) {
      apiMesFlowOrderApprovalHeader({ headId: this.headId }).then(res => {
        this.detail = res.data
        this.processInstanceId = this.detail?.processInstanceId || ''
      })
      this.queryParams.headId = this.headId || null
      this.tableDataSource = []
      // type='4'为工单变更流程
      apiMesGetMesFlowPathLinesList({ headId: this.headId, type: this.detailType, pageSize: 9999999 }).then(res => {
        if (res?.code === 200) {
          this.tableDataSource = res?.data || []
          this.tableDataSource.forEach((item, index) => {
            this.$set(this.tableDataSource[index], 'responsibleParty', item.responsibleParty ? item.responsibleParty?.split(',') : undefined)
          })
        } else {
          this.tableDataSource = []
        }
      })
    }
  },
  mounted () {
    this.initDetailTableAreaHeight()
  },
  methods: {
    moment,
    // 当【变更责任方】变化时，赋值name值
    onChangeResponsibleParty(record) {
      const getChangeLiability = this.changeLiabilityList?.filter(item => record.responsibleParty?.includes(item.lookupCode))
      if(getChangeLiability?.length > 0) {
        record.responsiblePartyName = getChangeLiability.map(item => item.lookupValue).join(',')
      } else {
        record.responsiblePartyName = ''
      }
    },
    // 当【是否主动变更】变化时，赋值name值
    onChangeActivePassive(record) {
      const getUpdateMethod = this.updateMethodList?.find(item => item.lookupCode === record.activePassive)
      record.activePassiveName = getUpdateMethod?.lookupValue ? getUpdateMethod.lookupValue : ''
    },
    searchTable: debounce(function() {
      this.searchFlag = true
      this.$nextTick(() => {
        this.searchFlag = false
        // this.$refs.detailTable.getData()
      })
    }, 300),
    // 初始化整合表头
    initGetTable() {
      this.newColumns = [...this.columns]
      apiMesFlowPathParamDefineList({ type: this.detailType }).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          res.data.forEach(item => {
            // display为1显示
            if(item.display === 1) {
              const column = {
                title: item.attrName,
                dataIndex: item.attrCode,
                align: 'center',
                width: item.width || 120,
                ellipsis: !!item.ellipsis
              }
              // 原考核交期和新考核交期要根据零部件和成品区分展示交期日期，零部件展示时分秒，成品不用
              if(['assessmentDeliveryDate'].includes(item.attrCode)) {
                column.scopedSlots = { customRender: 'assessmentDeliveryDateForm' }
              }
              if(item.attrCode === 'workshopMcName') {
                column.scopedSlots = { title: "workshopMcNameTitle" }
                delete column.title
              } else if(this.editFieldList.includes(item.attrCode)) {
                this.editFieldList.forEach(field => {
                  if(field === item.attrCode) {
                    column.scopedSlots = { customRender: field, title: `${field}Title` }
                    delete column.title
                  }
                })
              }
              this.newColumns.push(column)
            }
          })
        }
      })
    },
    initDetailTableAreaHeight () {
      const viewportHeight = window.innerHeight;
      if(this.$refs?.refBaseInfo) {
        this.detailTableHeight = viewportHeight - this.$refs.refBaseInfo.$el.offsetHeight - 208
      }
    },
    // 审批方法
    examineAndApprove () {
      const apiKey = process.env.VUE_APP_API_SCM_GYL_URL_api_key
      const apiSecret = process.env.VUE_APP_API_SCM_GYL_URL_api_secret
      const timestamp = new Date().getTime()
      const sign = md5(apiKey.toString() + timestamp.toString() + apiSecret.toString());
      const url = `${process.env.VUE_APP_API_SCM_GYL_URL}/api/kernel-flow/external/bpm/approveProcess?apiKey=${apiKey}&apiSecret=${apiSecret}&timestamp=${timestamp}&sign=${sign}`
      const params = {
        assignee: this.jobCode, // 当前登陆用户
        billNo: this.detail.billNo, // 单号
        comment: this.detail.comment || "", // 审批意见
        processCode: this.detail.processCoding, // 流程编码
        variables: {
          billRowId: this.headId,
          approvalRemarks: this.detail.comment || "",
          approveList: this.tableDataSource.map(item => {
            return {
              wipEntityId: item.wipEntityId,
              // approvalStatus: item.approvalStatusTwo,
              newAssessmentDeliveryDate: item.newAssessmentDeliveryDate,
              assessmentChangeQuantity: item.assessmentChangeQuantity || '' // 交期变更套数
            }
          })
        }
      }
      // 工单物料变更，要多传参数
      if(this.detailType === '5') {
        params.variables.approveList = this.tableDataSource.map(item => {
          return {
            wipEntityId: item.wipEntityId,
            newAssessmentDeliveryDate: item.newAssessmentDeliveryDate,
            assessmentChangeQuantity: item.assessmentChangeQuantity || '', // 交期变更套数
            mesRequirementOperationsId: item.dataId, // 工单用料id
            changedItemCode: item.changedItemCode, // 变更后的物料编码
            changedQuantityPerAssembly: item.changedQuantityPerAssembly // 变更后用量
          }
        })
      }
      const this_ = this
      apiKernelFlowExternalBpm(url, params).then(res => {
        if (res.state === 100) {
          this_.$message.success("审核成功")
          this_.handleSave() // 执行保存
        } else {
          this_.$message.error(res.msg)
          this_.btnLoading = false
        }
      }).catch(e => {
        this_.btnLoading = false
      })
    },
    // 审核
    handleApprove(status) {
      const getList = this.tableDataSource.filter(item => item.workshopMcCode === this.jobCode)
      // 驳回不执行必填校验
      if(status === 'approve' && getList?.length > 0) {
        const getRequiredList = getList.find(item => !item.activePassive || !item.newAssessmentDeliveryDate || !item.changeReason || !item.responsibleParty || item.assessmentChangeQuantity === null || item.assessmentChangeQuantity === undefined)
        if(getRequiredList) {
          this.$message.warning("请填写必填项")
          return false
        }
      }
      this.approvalFlag = status;
      this.showApproveModal = true
      const this_ = this
      setTimeout(() => {
        this_.$refs.approveModalRef.show(status)
      }, 200)
    },
    // 更新数据
    handleSave() {
      // 只更新管控是登录本人，有权限编辑的数据
      const getList = this.tableDataSource.filter(item => item.workshopMcCode === this.jobCode)
      const params = cloneDeep(getList)
      if(params?.length > 0) {
        params.forEach(item => {
          item.responsibleParty = item.responsibleParty ? item.responsibleParty?.join(',') : undefined
        })
        this.btnLoading = true
        apiUpdateMesFlowPathLines(params).then(res => {
          if(res?.code === 200) {
            this.closeFun()
          } else{
            this.btnLoading = false
          }
        }).catch(() => {
          this.btnLoading = false
        })
      } else {
        this.closeFun()
      }
    },
    // 审批完成后回调
    afterApprove(data) {
      this.detail.comment = data.comment
      this.handleApproveFun()
    },
    // 判断执行同意还是驳回
    handleApproveFun() {
      if(this.approvalFlag === "approve") {
        this.handleRatify()
      } else {
        this.handleRefuse()
      }
    },
    // 批准
    handleRatify () {
      this.btnLoading = true
      this.examineAndApprove()
    },
    // 拒绝
    handleRefuse () {
      this.btnLoading = true
      const params = {
        billRowId: this.headId,
        comment: this.detail.comment || "", // 审批意见
        approvalRemarks: this.detail.comment || "",
        processCode: this.detail.processCoding, // 流程编码
        assignee: this.jobCode, // 当前登陆用户
        approveList: this.tableDataSource.map(item => {
          return {
            wipEntityId: item.wipEntityId,
            // approvalStatus: item.approvalStatusTwo,
            newAssessmentDeliveryDate: item.newAssessmentDeliveryDate
          }
        })
      }
      apiMesTerminateProcess(params).then(res => {
        if(res.code === 200) {
          this.$message.success("拒绝成功")
          this.handleSave() // 执行保存
        } else {
          this.btnLoading = false
          this.$message.error(res.msg || '操作失败')
        }
      }).catch(() => {
        this.btnLoading = false
      })
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 关闭逻辑处理
    closeFun() {
      const this_ = this
      // if(this_.$refs?.approveModalRef) { this_.$refs.approveModalRef.onCancel() } // 关闭弹窗
      this_.showApproveModal = false
      setTimeout(() => {
        this_.btnLoading = false
        this_.handleClose()
      }, 1000)
    },
    handleClose () {
      this.event.$emit("close-current-page");
    }
  }
}
</script>

<style scoped lang="less">
.approval-status {
  /deep/.ant-select {
    width: 100%;
  }
}
input {
  width: 170px;
}
/deep/.ant-input-number{
  width: 170px;
}
/deep/.ant-calendar-picker{
  width: 150px;
}
.approval-input {
  input {
    width: 400px;
  }
}
.approval-btn{
  text-align: right;
  padding-right: 430px;
}
</style>
